import { request, getHeaders } from "./axios"

export const getFeeFilters = async () => {
  return request({
    url: "/fee-payment/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getFeeSort = async () => {
  return request({
    url: "/fee-payment/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getFeeAll = async (data = {}) => {
  return request({
    url: "/fee-payment/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createFee = async (data = {}) => {
  return request({
    url: "/fee-payment",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const approveFee = async (id) => {
  return request({
    url: "/fee-payment/approve",
    method: "PATCH",
    data: {
      id,
    },
    headers: await getHeaders(),
  })
}
export const escalateFee = async (id) => {
  return request({
    url: "/fee-payment/escalate",
    method: "PATCH",
    data: {
      id,
    },
    headers: await getHeaders(),
  })
}

export const getPaymentModes = async () => {
  return request({
    url: "/fee-payment/payment-modes",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getIncomeHeads = async (data = {}) => {
  return request({
    url: "/incomeHead/all",
    method: "POST",
    data: data,
    headers: await getHeaders(),
  })
}

export const searchIncomeHeads = async (keyword) => {
  return request({
    url: `/incomeHead/search?keyword=${keyword}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllExpense = async (data = {}) => {
  return request({
    url: "/expense/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createExpense = async (data = {}) => {
  return request({
    url: "/expense",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}
export const uploadExpenseInvoice = async (data = {}) => {
  return request({
    url: "/expense/upload",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getExpenseFilters = async () => {
  return request({
    url: "/expense/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getExpenseSort = async () => {
  return request({
    url: "/expense/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getExpenseTypes = async () => {
  return request({
    url: "/expense/types",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getExpenseHeads = async (data = {}) => {
  return request({
    url: "/expenseHead/all",
    method: "POST",
    data: data,
    headers: await getHeaders(),
  })
}

export const searchExpenseHeads = async (keyword) => {
  return request({
    url: `/expenseHead/search?keyword=${keyword}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getExpenseSubHeads = async (data = {}) => {
  return request({
    url: "/expenseSubHead/all",
    method: "POST",
    data: data,
    headers: await getHeaders(),
  })
}

export const searchExpenseSubHeads = async (keyword) => {
  return request({
    url: `/expenseSubHead/search?keyword=${keyword}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const findStudents = async (keyword) => {
  return request({
    url: "/student/search",
    method: "POST",
    data: {
      keyword,
      limit: 10,
    },
    headers: await getHeaders(),
  })
}

export const getProgramStats = async (data) => {
  return request({
    url: "/student/program-stats",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createIncome = async (data = {}) => {
  return request({
    url: "/income",
    method: "POST",
    data: data,
    headers: await getHeaders(),
  })
}

export const getAllIncome = async (data = {}) => {
  return request({
    url: "/income/all",
    method: "POST",
    data: data,
    headers: await getHeaders(),
  })
}
export const getIncomeFilters = async () => {
  return request({
    url: "/income/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getIncomeSort = async () => {
  return request({
    url: "/income/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const generateInvoice = async (id) => {
  return request({
    url: "/income",
    method: "PATCH",
    data: {
      id,
      generateInvoice: true,
    },
    headers: await getHeaders(),
  })
}

//-------------------INSTITUTIONS----------------------------
export const searchInstitutions = async (keyword) => {
  return request({
    url: "/institution/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

export const getInstitutionFilters = async () => {
  return request({
    url: "/institution/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getInstitutionSort = async () => {
  return request({
    url: "/institution/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllInstitutions = async (data = {}) => {
  return request({
    url: "/institution/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createInstitution = async (data = {}) => {
  return request({
    url: "/institution",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const editInstitution = async (data = {}) => {
  return request({
    url: "/institution",
    method: "PUT",
    data,
    headers: await getHeaders(),
  })
}

export const getInstitution = async (id) => {
  return request({
    url: `/institution?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeInstitution = async (id) => {
  return request({
    url: `/institution/${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

//-------------------PROGRAMS----------------------------
export const searchPrograms = async (keyword) => {
  return request({
    url: "/program/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

export const getProgramFilters = async () => {
  return request({
    url: "/program/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getProgramSort = async () => {
  return request({
    url: "/program/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllPrograms = async (data = {}) => {
  return request({
    url: "/program/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createProgram = async (data = {}) => {
  return request({
    url: "/program",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const editProgram = async (data = {}) => {
  return request({
    url: "/program",
    method: "PUT",
    data,
    headers: await getHeaders(),
  })
}

export const getProgram = async (id) => {
  return request({
    url: `/program?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeProgram = async (id) => {
  return request({
    url: `/program/${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

//-------------------COURSES----------------------------

export const searchCourses = async (keyword) => {
  return request({
    url: "/course/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

export const getCourseFilters = async () => {
  return request({
    url: "/course/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getCourseSort = async () => {
  return request({
    url: "/course/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const createCourse = async (data = {}) => {
  return request({
    url: "/course",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}
export const getAllCourses = async (data = {}) => {
  return request({
    url: "/course/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getCourseStats = async (id) => {
  return request({
    url: `/course?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

//-------------------Batches----------------------------
export const getBatches = async (data = {}) => {
  return request({
    url: "/batch/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createBatch = async (data = {}) => {
  return request({
    url: "/batch",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}
export const searchBatchDepositor = async (keyword) => {
  return request({
    url: "/batch/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

//-------------------Notes----------------------------
export const getNotes = async (data = {}) => {
  return request({
    url: "/note/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createNote = async (data = {}) => {
  return request({
    url: "/note",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}
export const searchNotes = async (keyword) => {
  return request({
    url: "/note/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

//-------------------CLASS SCHEDULE----------------------------
export const createClassSchedule = async (data = {}) => {
  return request({
    url: "/classSchedule",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

//-------------------CLASSES----------------------------

export const getClassFilters = async () => {
  return request({
    url: "/class/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getClassSort = async () => {
  return request({
    url: "/class/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllClasses = async (data = {}) => {
  return request({
    url: "/class/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getUpcomingClasses = async () => {
  return request({
    url: "/class/upcoming",
    method: "POST",
    headers: await getHeaders(),
  })
}

export const getPreviousClasses = async () => {
  return request({
    url: "/class/previous",
    method: "POST",
    headers: await getHeaders(),
  })
}

//--------------STUDENT------------------

export const getAllStudents = async (data = {}) => {
  return request({
    url: "/student/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getProgramStudents = async (data = {}) => {
  return request({
    url: "/student/program-stats",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getStudentFilters = async () => {
  return request({
    url: "/student/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getStudentSort = async () => {
  return request({
    url: "/student/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const editStudent = async (data = {}) => {
  return request({
    url: "/student",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getStudent = async (id) => {
  return request({
    url: `/student?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

//--------------TEACHERS------------------

export const searchTeachersDepositor = async (keyword) => {
  return request({
    url: "/teacher/search",
    method: "POST",
    data: {
      keyword,
    },
    headers: await getHeaders(),
  })
}

export const getAllTeacher = async (data = {}) => {
  return request({
    url: "/teacher/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getTeacherFilters = async () => {
  return request({
    url: "/teacher/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getTeacherSort = async () => {
  return request({
    url: "/teacher/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const editTeacher = async (data = {}) => {
  return request({
    url: "/teacher",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getTeacher = async (id) => {
  return request({
    url: `/teacher?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeFaculty = async (id) => {
  return request({
    url: `/teacher?id=${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

//--------------ADMISSION------------------

export const createAdmission = async (data = {}) => {
  return request({
    url: "/admission",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const updateAdmission = async (data = {}) => {
  return request({
    url: "/admission",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getAdmission = async (userId) => {
  return request({
    url: "/admission?userId=" + userId,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeAdmission = async (id) => {
  return request({
    url: `/admission?id=${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

//--------------CONTRACT------------------

export const createEmploymentContract = async (data = {}) => {
  return request({
    url: "/employmentContract",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const editEmploymentContract = async (data = {}) => {
  return request({
    url: "/employmentContract",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getEmploymentContract = async (id) => {
  return request({
    url: `/employmentContract?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeEmploymentContract = async (id) => {
  return request({
    url: `/employmentContract?id=${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

//--------------FEE SCHEDULE------------------

export const createFeeSchedule = async (data = {}) => {
  return request({
    url: "/fee-schedule",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

//--------------AdmissionEvent------------------

export const createAdmissionEvent = async (data = {}) => {
  return request({
    url: "/admissionEvent",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAllAdmissionEvents = async (data = {}) => {
  return request({
    url: "/admissionEvent/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAdmissionEventFilters = async () => {
  return request({
    url: "/admissionEvent/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAdmissionEventSort = async () => {
  return request({
    url: "/admissionEvent/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAdmissionEvent = async (id) => {
  return request({
    url: `/admissionEvent?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}
//--------------ACCOUNTING----------------------

export const getFeeStats = async (data = {}) => {
  return request({
    url: "/fee-payment/stats",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const searchDepositor = async (keyword) => {
  return request({
    url: "/income/search/depositor",
    method: "POST",
    data: {
      keyword,
      limit: 10,
    },
    headers: await getHeaders(),
  })
}

export const searchAccountDepositor = async (data) => {
  return request({
    url: "/account/search",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAccountStats = async (body) => {
  return request({
    url: "/account/stats",
    method: "POST",
    data: body,
    headers: await getHeaders(),
  })
}

//--------------ACCOUNT------------------

export const getAllAccounts = async (data = {}) => {
  return request({
    url: "/account/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAccountFilters = async () => {
  return request({
    url: "/account/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAccountSort = async () => {
  return request({
    url: "/account/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const editAccount = async (data = {}) => {
  return request({
    url: "/account",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const createAccount = async (data = {}) => {
  return request({
    url: "/account",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAccount = async (id) => {
  return request({
    url: `/account?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeAccount = async (id) => {
  return request({
    url: `/account/${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

export const accountTransfer = async (data = {}) => {
  return request({
    url: "/accountTransfer",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

// ----- SIDE BAR -----------

export const getDailyScheduleData = async (data = {}) => {
  return request({
    url: "/evaluation-stats",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getActivity = async (data = {}) => {
  return request({
    url: "/activity/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

// --- NOTIFICATIONS ------------

export const getNotifications = async (data = {}) => {
  return request({
    url: "/notification/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getNotificationsUnread = async () => {
  return request({
    url: "/notification/unread",
    method: "GET",
    headers: await getHeaders(),
  })
}

// --- ASSIGNMENTS ------------

export const getAssignments = async (data = {}) => {
  return request({
    url: "/assignment/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAllDepartments = async (data = {}) => {
  return request({
    url: "/department/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAllFeeHeads = async (data = {}) => {
  return request({
    url: "/feeHead/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const searchFeeHeads = async (keyword) => {
  return request({
    url: `/feeHead/search?keyword=${keyword}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllDegree = async () => {
  return request({
    url: "/program/degree",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAllStaff = async (data = {}) => {
  return request({
    url: "/staff/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getStaffFilters = async () => {
  return request({
    url: "/staff/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getStaffSort = async () => {
  return request({
    url: "/staff/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const removeStaff = async (id) => {
  return request({
    url: `/staff?id=${id}`,
    method: "DELETE",
    headers: await getHeaders(),
  })
}

export const approveEscalate = async (type, action, id) => {
  return request({
    url: `/${type}/${action}?id=${id}`,
    method: "GET",

    headers: await getHeaders(),
  })
}

export const getStudentFee = async (id) => {
  return request({
    url: "/fee-payment/student?keyword=" + id,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const editStaff = async (data = {}) => {
  return request({
    url: "/staff",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getStaff = async (id) => {
  return request({
    url: `/staff?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

//--------------ASSET------------------

export const getAllAssets = async (data = {}) => {
  return request({
    url: "/asset/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getAssetFilters = async () => {
  return request({
    url: "/asset/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getAssetSort = async () => {
  return request({
    url: "/asset/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const createAsset = async (data = {}) => {
  return request({
    url: "/asset",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const editAsset = async (data = {}) => {
  return request({
    url: "/asset",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getAsset = async (id) => {
  return request({
    url: `/asset?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

//--------------INVENTORY------------------

export const getAllInventories = async (data = {}) => {
  return request({
    url: "/inventory/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getInventoryFilters = async () => {
  return request({
    url: "/inventory/filters",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getInventorySort = async () => {
  return request({
    url: "/inventory/sort",
    method: "GET",
    headers: await getHeaders(),
  })
}

export const createInventory = async (data = {}) => {
  return request({
    url: "/inventory",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const editInventory = async (data = {}) => {
  return request({
    url: "/inventory",
    method: "PATCH",
    data,
    headers: await getHeaders(),
  })
}

export const getInventory = async (id) => {
  return request({
    url: `/inventory?id=${id}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

// NOTICE--------------------------------------------------------------

export const getAllNotice = async (data = {}) => {
  return request({
    url: "/notice/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createNotice = async (data = {}) => {
  return request({
    url: "/notice",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const createChannel = async (data = {}) => {
  return request({
    url: "/channel",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

export const getChannels = async (data = {}) => {
  return request({
    url: "/channel/all",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}

// GET ADMISSION EVENT

export const fetchAdmissionEvent = async (academicYear, institutionId) => {
  return request({
    url: `/admissionEvent?academicYear=${academicYear}&institutionId=${institutionId}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

// GET INSTITUTES

export const searchInstitutes = async (val) => {
  return request({
    url: `/institution/search?keyword=${val}`,
    method: "GET",
    headers: await getHeaders(),
  })
}

export const getTransactions = async (data = {}) => {
  return request({
    url: "/transactions",
    method: "POST",
    data,
    headers: await getHeaders(),
  })
}
